import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    try {
      setLoading(true);
      const res = await axios.post('/api/auth/forgot-password', { email: email.trim() });
      toast.success(res?.data?.message || 'If the email exists, a reset link has been sent');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Failed to submit request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">Forgot password</h2>
          <p className="mt-2 text-gray-600">Enter your email and we’ll send reset instructions.</p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input
            type="email"
            className="input-field"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit" disabled={loading} className="w-full btn-primary">
            {loading ? 'Submitting...' : 'Send reset link'}
          </button>

          <div className="text-center text-sm">
            <Link to="/login" className="text-purple-600 hover:text-purple-500 font-medium">Back to login</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
